package com.eladfinish.bible.contest.screens.mikud.ui.dialogs

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.analytics.crashlytics.AppCrashlytics
import com.eladfinish.bible.contest.books_and_chapters
import com.eladfinish.bible.contest.help
import com.eladfinish.bible.contest.material
import com.eladfinish.bible.contest.menu_refresh
import com.eladfinish.bible.contest.mikudGuide_txt
import com.eladfinish.bible.contest.screens.mikud.model.toLocalizedStringDesc
import com.eladfinish.bible.contest.screens.mikud.mvi.MikudAction
import com.eladfinish.bible.contest.screens.mikud.mvi.MikudState
import com.eladfinish.bible.contest.ui.common.rememberSafeUriHandler
import com.eladfinish.bible.contest.ui.components.dialogs.BasicDialogWithTitle
import com.eladfinish.bible.contest.ui.components.dialogs.DialogWithInputField
import com.eladfinish.bible.contest.ui.components.dialogs.GeneralHelpDialog
import com.eladfinish.bible.contest.ui.components.dialogs.HelpContentType
import com.eladfinish.bible.contest.ui.components.dialogs.InputDialogMode
import dev.icerock.moko.resources.compose.localized
import dev.icerock.moko.resources.compose.stringResource
import dev.icerock.moko.resources.desc.desc

@Composable
internal fun MikudDialogs(
    dialogState: MikudState.DialogState,
    onAction: (MikudAction) -> Unit,
) {
    when (dialogState) {
        MikudState.DialogState.None -> Unit

        is MikudState.DialogState.Help -> {
            GeneralHelpDialog(
                titleResource = SharedRes.strings.help,
                helpContentType = HelpContentType.Asset(SharedRes.assets.other.mikudGuide_txt),
                isDontShowAgainChecked = dialogState.isDontShowAgainChecked,
                onApproveDialog = {
                    onAction(MikudAction.ToggleHelp(shouldShowNextTime = it))
                },
                onDismiss = {
                    onAction(MikudAction.HideDialog)
                },
            )
        }

        is MikudState.DialogState.MikudSummary -> {
            SimpleMessageDialog(
                onDismiss = {
                    onAction(MikudAction.HideDialog)
                },
                title = "${stringResource(SharedRes.strings.material)}\n${stringResource(SharedRes.strings.books_and_chapters)}:",
                content = dialogState.summary.toLocalizedStringDesc().localized(),
            )
        }

        is MikudState.DialogState.LoadMikudMenu -> {
            LoadMikudDialog(
                state = dialogState,
                onAction = onAction,
            )
        }

        is MikudState.DialogState.MikudLevels -> {
            val safeUriHandler = rememberSafeUriHandler { throwable, _ ->
                AppCrashlytics.logException(throwable)
//                showSnackbar("אין אפליקציה שיכולה לפתוח קישורים במכשיר הזה", null, SnackbarDuration.Short) {}
                // תבחר מה מתאים לך:
                // showSnackbar(SharedRes.strings.no_browser_installed.desc(), null, SnackbarDuration.Short) {}
                onAction(MikudAction.HideDialog) // או כל fallback אחר
            }

            BasicDialogWithTitle(
                title = dialogState.title,
                onDismiss = { onAction(MikudAction.HideDialog) },
                onCancel = { onAction(MikudAction.HideDialog) },
                onAction = { onAction(MikudAction.RefreshMikudLevels(dialogState.mikudType)) },
                actionText = SharedRes.strings.menu_refresh.desc(),
            ) {
                MikudLevelsContentDialog(
                    text = dialogState.annotatedText,
                    onMikudLevelClick = { payload ->
                        onAction(MikudAction.MikudLevelClicked(payload))
                    },
                    onUrlClick = { url ->
                        safeUriHandler.openUri(url)
                    }
                )
            }
        }

        is MikudState.DialogState.MikudNameEntry -> {
            DialogWithInputField(
                label = dialogState.title.localized(),
                initialValue = dialogState.initialValue,
                mode = InputDialogMode.CREATE,
                onConfirm = { name ->
                    onAction(MikudAction.SaveMikudWithName(name))
                },
                onDismiss = {
                    onAction(MikudAction.HideDialog)
                },
            )
        }

        is MikudState.DialogState.MikudRenameEntry -> {
            DialogWithInputField(
                label = dialogState.title.localized(),
                initialValue = dialogState.initialValue,
                mode = InputDialogMode.RENAME,
                onConfirm = { name ->
                    onAction(
                        MikudAction.RenameMikud(
                            oldName = dialogState.initialValue,
                            newName = name
                        )
                    )
                },
                onDismiss = {
                    onAction(MikudAction.HideDialog)
                },
            )
        }

        is MikudState.DialogState.ConfirmDeleteSavedMikud -> {
            ConfirmDeleteMikudDialog(
                name = dialogState.name,
                onConfirm = { onAction(MikudAction.ConfirmDeleteSavedMikud(name = dialogState.name)) },
                onCancel = { onAction(MikudAction.CancelDeleteSavedMikud) },
            )
        }

        is MikudState.DialogState.PremiumRequired -> {
            BasicDialogWithTitle(
                title = "שדרוג נדרש",
                onDismiss = { onAction(MikudAction.HideDialog) }
            ) {
                Column(modifier = Modifier.padding(16.dp)) {
                    Text(dialogState.message)
                    Text(
                        "לחץ כאן לשדרוג",
                        modifier = Modifier
                            .padding(top = 16.dp)
                            .clickable { onAction(MikudAction.PurchasePremiumClicked) },
                        textDecoration = TextDecoration.Underline
                    )
                }
            }
        }

        is MikudState.DialogState.RemoteMikudMenu -> {
            RemoteMikudMenuDialog(
                state = dialogState,
                onAction = onAction,
            )
        }
    }
}
